export class TeardownAwsPrivateLinkResponse {
    'workflowId';
    static discriminator = undefined;
    static attributeTypeMap = [
        {
            "name": "workflowId",
            "baseName": "workflowId",
            "type": "string",
            "format": ""
        }
    ];
    static getAttributeTypeMap() {
        return TeardownAwsPrivateLinkResponse.attributeTypeMap;
    }
    constructor() {
    }
}
